<template>
  <div :class="computedBaseClasses">
    <div
      :class="computedBarClasses"
      :style="{ width: barWidth }"
    />
  </div>
</template>

<script setup lang="ts">
import type { ProgressSize, ProgressVariant } from './types'

const props = withDefaults(defineProps<{
  value: number
  max?: number
  size?: ProgressSize
  variant?: ProgressVariant
  isFullWidth?: boolean
}>(), {
  max: 100,
  size: 'md',
  variant: 'default',
})

const barWidth = computed(() => {
  if (props.max <= 0) {
    return '0%'
  }

  if (props.value > props.max) {
    return '100%'
  }

  return `${Math.floor((props.value / props.max) * 100)}%`
})

const isAtMax = computed(() => props.value >= props.max)

const computedBaseClasses = computed(() => [
  'overflow-hidden w-full',
  {
    'rounded-full': !props.isFullWidth,
    'h-1': props.size === 'sm',
    'h-2': props.size === 'md',
    'h-4': props.size === 'lg',
  },
  {
    'bg-gray-200': props.variant === 'default',
    'bg-primary-100': props.variant === 'highlight',
  },
])

const computedBarClasses = computed(() => [
  'h-full bg-secondary transition-all duration-300',
  {
    'rounded-full': !props.isFullWidth,
    'rounded-e-full': props.isFullWidth && !isAtMax.value,
    'rounded-none': props.isFullWidth && isAtMax.value,
  },
])
</script>
